<template>
<div>我是春天</div>
</template>

<script>
export default {
  name: "Spring"
}
</script>

<style scoped>
div{
  width: 100px;
  height: 100px;
  margin: 0 auto;
  background: green;
}
</style>